// src/locales/German/de.termsOfUse.ts


const termsOfUse = {

    termsOfUse: {
  meta: {
    title: "{{appName}} — Nutzungsbedingungen",
    closeAria: "Schließen",
    closeTitle: "Schließen",
    lastUpdated: "Zuletzt aktualisiert: {{date}}",
    top: "↑ Nach oben",
    print: "Drucken / Als PDF speichern",
    contact: "Kontakt",
    copyright: "© {{year}} {{companyName}}. Alle Rechte vorbehalten.",
  },

  nav: {
    introduction: "Einleitung",
    eligibility: "Teilnahmeberechtigung",
    account: "Konto",
    service: "Dienst",
    content: "Nutzerinhalte",
    music: "Musik & Audio",
    acceptableUse: "Zulässige Nutzung",
    community: "Community-Standards",
    ip: "Geistiges Eigentum",
    copyright: "Urheberrecht",
    thirdParty: "Dienste Dritter",
    termination: "Beendigung",
    availability: "Verfügbarkeit",
    liability: "Haftung",
    indemnity: "Freistellung",
    changes: "Änderungen",
    law: "Anwendbares Recht",
    contact: "Kontakt",
  },

  introduction: {
    title: "1. Allgemeines",

    welcome: "Willkommen bei {{appName}}!",

    body:
      "{{appName}} ist eine Social-Media-Plattform, die es Nutzern ermöglicht, Inhalte zu entdecken, Erlebnisse zu teilen, mit anderen in Kontakt zu treten und über die vom Dienst bereitgestellten Funktionen zu kommunizieren. In diesen Nutzungsbedingungen bezeichnet der Begriff „Dienst“ {{appName}}, einschließlich der Website, Anwendungen, Funktionen zum Teilen von Inhalten, Nachrichtenfunktionen, standortbezogenen Funktionen sowie aller damit verbundenen Dienste. Diese Nutzungsbedingungen regeln deinen Zugriff auf und die Nutzung des Dienstes. Durch die Erstellung eines Kontos, den Zugriff auf oder die Nutzung des Dienstes erklärst du dich mit diesen Nutzungsbedingungen einverstanden. Falls du nicht zustimmst, darfst du den Dienst nicht nutzen.",
  },

  eligibility: {
    title: "2. Teilnahmeberechtigung",
    bullets: [
      "Du musst mindestens **18 Jahre alt** sein, um {{appName}} zu nutzen.",
      "Du musst rechtlich berechtigt sein, diesen Nutzungsbedingungen zuzustimmen und sie einzuhalten.",
      "Du musst alle geltenden Gesetze und Vorschriften einhalten.",
      "Du darfst {{appName}} nicht nutzen, wenn dein Konto zuvor von uns gesperrt oder dauerhaft geschlossen wurde.",
    ],
  },

  account: {
    title: "3. Dein Konto",
    body:
      "Dein Konto ist persönlich und darf nur von dir genutzt werden. Du bist für die Sicherheit deines Kontos sowie für sämtliche Aktivitäten verantwortlich, die darüber erfolgen.",

    bullets: [
      "Bewahre deine Anmeldedaten sicher und vertraulich auf.",
      "Teile, verkaufe, übertrage oder überlasse dein Konto keiner anderen Person.",
      "Informiere uns unverzüglich, wenn du glaubst, dass dein Konto kompromittiert wurde.",
      "Nutze dein Konto in Übereinstimmung mit diesen Nutzungsbedingungen und den geltenden Gesetzen.",
      "Zum Schutz der Nutzer, des Dienstes oder zur Erfüllung gesetzlicher Verpflichtungen können wir bei Bedarf zusätzliche Informationen oder eine Identitätsprüfung verlangen.",
    ],
  },

  service: {
    title: "4. Beschreibung des Dienstes",
    body:
      "{{appName}} ist eine soziale Plattform, die es Nutzern ermöglicht, Profile zu erstellen, Inhalte zu teilen, öffentliche Beiträge zu entdecken, mit anderen Nutzern zu interagieren, über private Nachrichten zu kommunizieren und standortbezogene Funktionen zu nutzen.",

    bullets: [
      "**Profile**: Nutzer können ein Profil erstellen und verwalten.",
      "**Inhalte teilen**: Nutzer können Fotos, Videos und andere über den Dienst verfügbare Inhalte hochladen und teilen.",
      "**Entdecken**: Nutzer können öffentliche Inhalte anderer Nutzer entdecken.",
      "**Standortbezogene Funktionen**: Standortinformationen werden beim Teilen von Inhalten, für Entdeckungsfunktionen, Inhalte in der Nähe sowie Standortkennzeichnungen von Beiträgen verwendet. Für das Erstellen eines Beitrags sind Standortinformationen erforderlich, um Standortkennzeichnungen zu bestimmen und standortbezogene Funktionen sowie die Auffindbarkeit von Inhalten innerhalb des Dienstes zu ermöglichen. Werden keine Standortberechtigungen erteilt, steht das Veröffentlichen von Inhalten möglicherweise nicht zur Verfügung.",
      "**Kategorisierung von Inhalten**: Inhalte können über Standortkennzeichnungen, versteckte Hashtags, Musikzuordnungen und ähnliche Organisationsfunktionen innerhalb des Dienstes kategorisiert und gefunden werden.",
      "**Soziale Interaktionen**: Nutzer können anderen folgen, Inhalte mit „Gefällt mir“ markieren, Nutzer blockieren, Nutzer oder Inhalte melden sowie Benachrichtigungen erhalten.",
      "**Nachrichten**: Nutzer können über private Nachrichtenfunktionen miteinander kommunizieren.",
      "Funktionen, Leistungsumfang und Verfügbarkeit des Dienstes können jederzeit geändert, eingeschränkt, ausgesetzt oder eingestellt werden.",
    ],
  },

  content: {
  title: "5. Nutzerinhalte",
  body:
    "Du behältst das Eigentum an den Inhalten, die du auf {{appName}} erstellst und hochlädst.",

  bullets: [
    "Durch das Veröffentlichen von Inhalten gewährst du {{companyName}} eine weltweite, nicht ausschließliche und gebührenfreie Lizenz, deine Inhalte zu hosten, zu speichern, anzuzeigen, zu verbreiten, zu vervielfältigen, zu verarbeiten und in dem Umfang bereitzustellen, der für den Betrieb, die Bereitstellung, Verbesserung, den Schutz und die Unterstützung des Dienstes erforderlich ist.",
    "Du bestätigst, dass du über alle erforderlichen Rechte, Genehmigungen und Befugnisse verfügst, um deine Inhalte hochzuladen, zu teilen und über den Dienst bereitzustellen.",
    "Du bist dafür verantwortlich, sicherzustellen, dass deine Inhalte weder gegen geltendes Recht noch gegen die Rechte anderer Personen oder Organisationen verstoßen.",
    "Öffentliche Inhalte können für andere Nutzer sichtbar sein und gegebenenfalls mit deinem Profil sowie Standortkennzeichnungen verknüpft werden."
  ],

  licenseEnd:
    "Diese Lizenz endet mit der Löschung deiner Inhalte, es sei denn, eine weitere Speicherung ist aus rechtlichen Gründen, zur Sicherheit, Moderation, Datensicherung, Streitbeilegung oder aus technischen Gründen erforderlich.",
},

music: {
  title: "6. Musik- und Audioinhalte",

  body:
    "{{appName}} kann Zugriff auf Musik, Audiotitel, Soundeffekte oder andere Audioinhalte bereitstellen, die im Zusammenhang mit den Funktionen des Dienstes genutzt werden können.",

  bullets: [
    "Über den Dienst bereitgestellte Musik- und Audioinhalte können Eigentum von {{companyName}} sein oder von Dritten lizenziert werden.",
    "Die Nutzung von Musik- und Audioinhalten ist ausschließlich innerhalb des Dienstes und gemäß diesen Nutzungsbedingungen gestattet.",
    "Nutzer sind dafür verantwortlich sicherzustellen, dass von ihnen hochgeladene oder bereitgestellte Audioinhalte keine Rechte Dritter verletzen.",
    "Die Verfügbarkeit bestimmter Musik- oder Audioinhalte kann je nach Region, Funktion, Lizenzbeschränkungen oder Zeitraum variieren.",
    "Wir können Musik- und Audioinhalte jederzeit hinzufügen, ändern, einschränken oder entfernen."
  ],
},

acceptableUse: {
  title: "7. Zulässige Nutzung",
  bullets: [
    "Verstoße nicht gegen geltende Gesetze oder Vorschriften.",
    "Verletze keine Rechte des geistigen Eigentums, Datenschutzrechte, Persönlichkeitsrechte oder sonstige Rechte Dritter.",
    "Belästige, bedrohe, missbrauche, schüchtere, verfolge oder nutze andere Personen nicht aus.",
    "Veröffentliche keine hasserfüllten, gewalttätigen, extremistischen, terroristischen, sexuell ausbeuterischen oder anderweitig schädlichen Inhalte.",
    "Veröffentliche keine betrügerischen, irreführenden, täuschenden oder Identitäten vortäuschenden Inhalte.",
    "Gib dich nicht als eine andere Person, ein Unternehmen, eine Organisation, eine Marke oder eine Person des öffentlichen Lebens aus.",
    "Verwende Profilnamen, Marken oder Markenzeichen nicht in einer Weise, die fälschlicherweise eine Zugehörigkeit, Unterstützung oder offizielle Vertretung suggeriert.",
    "Teile keine privaten oder sensiblen Informationen anderer Personen ohne deren Zustimmung.",
    "Verbreite keine Schadsoftware, schädlichen Code, Spam oder automatisierten Missbrauch.",
    "Greife ohne Erlaubnis keine Daten des Dienstes durch Scraping, Crawling, Kopieren oder Extrahieren ab.",
    "Umgehe, störe, analysiere, manipuliere oder greife den Dienst, Sicherheitssysteme, Ratenbegrenzungen oder technische Schutzmaßnahmen nicht an.",
    "Nutze keine Bots, automatisierten Werkzeuge, künstliche Interaktionen oder koordinierte Manipulationen ohne unsere Genehmigung.",
    "Kopiere, extrahiere, lade herunter, verbreite, verkaufe oder nutze Musik- oder Audioinhalte außerhalb des Dienstes nur, wenn dies ausdrücklich erlaubt ist.",
    "Politische Werbung, politische Kampagnen oder koordinierte politische Botschaften sind nicht gestattet."
  ],
},

community: {
  title: "8. Community-Standards",
  body:
    "Von allen Nutzern wird erwartet, dass sie zu einer sicheren, respektvollen und vertrauenswürdigen Community beitragen. Zusätzlich zu diesen Nutzungsbedingungen müssen Nutzer die Community-Richtlinien von {{appName}} sowie alle Richtlinien einhalten, die für bestimmte Funktionen des Dienstes gelten.",

  bullets: [
    "Wir können Inhalte überprüfen, entfernen, einschränken oder deaktivieren, wenn sie gegen diese Nutzungsbedingungen, unsere Community-Richtlinien, geltendes Recht oder die Sicherheit und Integrität des Dienstes verstoßen.",
    "Wir können die Sichtbarkeit von Inhalten einschränken, den Zugriff auf Funktionen beschränken, Verwarnungen aussprechen, Konten vorübergehend sperren oder dauerhaft schließen, sofern dies angemessen ist.",
    "Maßnahmen können auf Grundlage von Nutzermeldungen, automatisierten Systemen, internen Prüfungen, gesetzlichen Anforderungen oder anderen uns vorliegenden Informationen erfolgen.",
    "Durchsetzungsentscheidungen treffen wir nach billigem Ermessen unter Berücksichtigung der Schwere, Häufigkeit und des Zusammenhangs eines Verstoßes.",
    "Wiederholte, schwerwiegende oder vorsätzliche Verstöße können zu dauerhaften Einschränkungen oder zur Schließung des Kontos führen."
  ],
},

ip: {
  title: "9. Geistiges Eigentum",
  body:
    "{{appName}} einschließlich seiner Software, Technologie, seines Designs, seiner Benutzeroberfläche, seines Brandings, seiner Logos, Marken, Funktionen, Musik- und Audioinhalte sowie aller anderen über den Dienst bereitgestellten Materialien ist Eigentum von {{companyName}} oder dessen Lizenzgebern und durch die geltenden Gesetze zum Schutz des geistigen Eigentums geschützt. Soweit in diesen Nutzungsbedingungen nicht ausdrücklich gestattet, ist es dir untersagt, Teile des Dienstes zu kopieren, zu verändern, zu verbreiten, zu verkaufen, zurückzuentwickeln (Reverse Engineering) oder davon abgeleitete Werke zu erstellen. Diese Nutzungsbedingungen übertragen dir weder Eigentum am Dienst noch Rechte am geistigen Eigentum von {{companyName}} oder dessen Lizenzgebern.",
},

copyright: {
  title: "10. Urheberrechtsbeschwerden",
  body:
    "Wir respektieren geistige Eigentumsrechte und erwarten dasselbe von unseren Nutzern. Wenn du der Ansicht bist, dass über {{appName}} verfügbare Inhalte dein Urheberrecht oder andere Rechte am geistigen Eigentum verletzen, kannst du uns eine entsprechende Mitteilung senden. Wir können den Sachverhalt prüfen, den betreffenden Inhalt entfernen oder den Zugriff darauf einschränken und bei wiederholten Verstößen geeignete Maßnahmen ergreifen.",

  agent:
    "{{companyName}}\n{{legalAddress}}\nE-Mail: {{dmcaEmail}}",
},

thirdParty: {
  title: "11. Dienste Dritter",
  body:
    "{{appName}} nutzt Drittanbieter und Infrastrukturdienste, um den Dienst zu betreiben, zu sichern, zu hosten, zu speichern, bereitzustellen und zu verbessern. Diese Anbieter können Daten in unserem Auftrag gemäß den geltenden Vereinbarungen und gesetzlichen Anforderungen verarbeiten.",

  bullets: [
    "Zu den Drittanbietern können Hosting-, Cloud-Infrastruktur-, Content-Delivery-, Speicher-, Sicherheits-, Kommunikations-, Analyse-, Standort- und weitere Technologieanbieter gehören.",
    "Die Verfügbarkeit und Leistung bestimmter Funktionen kann von Diensten Dritter abhängen, die außerhalb unseres angemessenen Einflussbereichs liegen.",
    "Wir sind nicht verantwortlich für Inhalte, Richtlinien, Praktiken oder die Verfügbarkeit von Websites, Diensten oder Plattformen Dritter, die nicht von {{companyName}} betrieben werden.",
    "Für die Nutzung von Diensten Dritter können deren eigene Nutzungsbedingungen und Richtlinien gelten."
  ],
},

termination: {
  title: "12. Sperrung, Deaktivierung und Beendigung des Kontos",

  body:
    "Du kannst die Nutzung von {{appName}} jederzeit beenden. Wenn du den Dienst nicht mehr nutzen möchtest, kannst du dein Konto über die verfügbaren Kontoeinstellungen deaktivieren oder löschen. Wir können dein Konto oder deinen Zugriff auf den Dienst sperren, einschränken, deaktivieren oder beenden, soweit dies angemessenerweise erforderlich ist.",

  bullets: [
    "Wenn du gegen diese Nutzungsbedingungen verstößt.",
    "Wenn du gegen unsere Community-Richtlinien oder andere geltende Richtlinien verstößt.",
    "Wenn dies gesetzlich, durch gerichtliche Anordnung oder behördliche Vorgaben erforderlich ist.",
    "Wenn deine Aktivitäten ein angemessenes Risiko für Nutzer, {{companyName}}, Dritte oder den Dienst darstellen.",
    "Wenn deine Aktivitäten die Sicherheit, Integrität oder den Betrieb des Dienstes gefährden.",
    "Wenn wir berechtigterweise annehmen, dass dein Konto kompromittiert, missbräuchlich oder betrügerisch genutzt wurde.",
    "Wenn du bei der Registrierung oder Nutzung deines Kontos falsche, irreführende oder unzutreffende Angaben machst."
  ],

  effect:
    "Eine Sperrung, Einschränkung, Deaktivierung oder Beendigung kann zum Verlust des Zugriffs auf dein Konto, dein Profil, Inhalte, Nachrichten, Follower, Einstellungen, erworbene Funktionen und andere Funktionen des Dienstes führen. Bestimmte Informationen können weiterhin gespeichert werden, soweit dies aus rechtlichen Gründen, zur Sicherheit, Betrugsprävention, Streitbeilegung, Datensicherung sowie für betriebliche oder technische Zwecke erforderlich ist."
},

availability: {
  title: "13. Verfügbarkeit des Dienstes",

  body:
    "Wir bemühen uns, einen zuverlässigen und sicheren Dienst bereitzustellen. Wir garantieren jedoch nicht, dass {{appName}} jederzeit verfügbar, unterbrechungsfrei, sicher, fehlerfrei oder frei von Verzögerungen, Datenverlusten oder Dienstunterbrechungen ist. Funktionen können jederzeit geändert, eingeschränkt, ausgesetzt oder eingestellt werden.",

  bullets: [
    "Die Verfügbarkeit und Leistung des Dienstes kann durch Wartungsarbeiten, Updates, technische Probleme, Drittanbieter, Netzwerkausfälle, Sicherheitsvorfälle oder Ereignisse außerhalb unseres angemessenen Einflussbereichs beeinträchtigt werden.",
    "Wir übernehmen keine Gewähr für die Speicherung, Verfügbarkeit, Zustellung oder Wiederherstellung von Inhalten, Nachrichten, Medien, Kontodaten oder sonstigen Informationen.",
    "Nutzer sind selbst dafür verantwortlich, Sicherungskopien von Inhalten aufzubewahren, die sie für wichtig halten.",
    "Soweit gesetzlich zulässig, haftet {{companyName}} nicht für Schäden, die durch Ausfälle, Unterbrechungen, Verzögerungen, Datenbeschädigungen, Datenverluste, fehlgeschlagene Datensicherungen oder technische Fehler entstehen."
  ],
},

liability: {
  title: "14. Gewährleistungsausschluss und Haftungsbeschränkung",

  body:
    'Der Dienst wird „wie besehen“ und „wie verfügbar“ bereitgestellt. Soweit gesetzlich zulässig, schließt {{companyName}} sämtliche ausdrücklichen, stillschweigenden, gesetzlichen oder sonstigen Gewährleistungen aus, einschließlich Gewährleistungen der Marktgängigkeit, der Eignung für einen bestimmten Zweck, der Nichtverletzung von Rechten Dritter, der Verfügbarkeit, Sicherheit, Genauigkeit, Zuverlässigkeit oder eines unterbrechungsfreien Betriebs.',

  bullets: [
    "{{companyName}} haftet nicht für indirekte, zufällige, besondere, Folge-, exemplarische, Straf- oder vergleichbare Schäden.",
    "{{companyName}} haftet nicht für den Verlust von Daten, Nachrichten, Inhalten, Medien, Gewinnen, Umsätzen, Geschäftswert, Ruf, Geschäftsmöglichkeiten oder sonstigen immateriellen Schäden.",
    "{{companyName}} haftet nicht für Ausfälle, Unterbrechungen, Verzögerungen, Dienststörungen, Datenbeschädigungen, Datenverluste, fehlgeschlagene Datensicherungen, unbefugte Zugriffe, Sicherheitsvorfälle oder Ausfälle, die durch Drittanbieter verursacht werden.",
    "{{companyName}} haftet nicht für Inhalte, Verhalten, Aussagen, Handlungen oder Unterlassungen von Nutzern oder Dritten.",
    "Soweit gesetzlich zulässig, ist unsere gesamte Haftung aus oder im Zusammenhang mit dem Dienst auf maximal 100 US-Dollar (USD 100) begrenzt."
  ],
},

indemnity: {
  title: "15. Freistellung",

  body:
    "Soweit gesetzlich zulässig erklärst du dich damit einverstanden, {{companyName}}, seine verbundenen Unternehmen, leitenden Angestellten, Direktoren, Mitarbeiter, Auftragnehmer, Partner, Lizenzgeber und Dienstleister von sämtlichen Ansprüchen, Schäden, Verlusten, Haftungen, Kosten und Aufwendungen (einschließlich angemessener Anwaltskosten) freizustellen und schadlos zu halten, die entstehen aus oder im Zusammenhang mit:",

  bullets: [
    "deiner Nutzung des Dienstes.",
    "deinen Inhalten, Beiträgen, Nachrichten, Medien oder sonstigen Materialien, die du über den Dienst bereitstellst.",
    "deinem Verstoß gegen diese Nutzungsbedingungen, unsere Community-Richtlinien oder andere geltende Richtlinien.",
    "deinem Verstoß gegen geltendes Recht oder Vorschriften.",
    "deiner Verletzung der Rechte einer anderen Person, Organisation oder Einrichtung, einschließlich geistiger Eigentumsrechte, Datenschutz-, Persönlichkeits- oder sonstiger gesetzlicher Rechte.",
    "Ansprüchen, die sich aus deinem Verhalten oder Missbrauch des Dienstes ergeben."
  ],
},

changes: {
  title: "16. Änderungen des Dienstes und der Nutzungsbedingungen",

  body:
    "Wir können den Dienst oder diese Nutzungsbedingungen von Zeit zu Zeit ändern, aktualisieren, verbessern, einschränken, aussetzen, einstellen oder anderweitig anpassen. Bei wesentlichen Änderungen können wir dich über den Dienst, per E-Mail oder auf andere angemessene Weise informieren.",

  notice:
    "Änderungen treten mit ihrer Veröffentlichung oder zu dem in der Mitteilung angegebenen Zeitpunkt in Kraft, sofern gesetzlich nichts anderes vorgeschrieben ist.",

  effect:
    "Indem du {{appName}} nach Inkrafttreten der Änderungen weiterhin nutzt oder darauf zugreifst, erklärst du dich mit den aktualisierten Nutzungsbedingungen einverstanden. Wenn du den Änderungen nicht zustimmst, musst du die Nutzung des Dienstes einstellen."
},

law: {
  title: "17. Anwendbares Recht",

  body:
    "Diese Nutzungsbedingungen sowie alle Streitigkeiten, die sich aus oder im Zusammenhang mit dem Dienst ergeben, unterliegen dem Recht des Bundesstaates Florida, Vereinigte Staaten von Amerika, und werden nach diesem ausgelegt, ohne Berücksichtigung kollisionsrechtlicher Vorschriften. Diese Nutzungsbedingungen beschränken oder schließen jedoch keine zwingenden Verbraucherrechte oder Schutzvorschriften aus, die nach dem Recht deines Wohnsitzlandes gelten und auf die nicht wirksam verzichtet werden kann.",
},

contact: {
  title: "18. Kontakt",
  body:
    "{{companyName}}\n{{companyAddress}}\n{{contactEmail}}",
},
},
} as const;

export default termsOfUse;